export const hasNestedProperty = (obj: unknown, keyPath: string): boolean => {
	if (typeof obj !== 'object' || obj === null) return false;

	let current: unknown = obj;

	for (const key of keyPath.split('.')) {
		if (
			typeof current === 'object' &&
			current !== null &&
			key in (current as Record<string, unknown>)
		) {
			current = (current as Record<string, unknown>)[key];
		} else {
			return false;
		}
	}

	return true;
};

/**
 * Strips leading zeros from the named string fields. IDM returns zero-padded
 * day and month values that the selects expect unpadded.
 */
export function removeZerosForSpecificFields<T extends Record<string, unknown>>(
	obj: T,
	keysToUpdate: (keyof T)[]
): T {
	const updatedObj: T = { ...obj };

	keysToUpdate.forEach((key) => {
		const value = updatedObj[key];
		if (typeof value === 'string') {
			updatedObj[key] = value.replace(/^0+/, '') as T[keyof T];
		}
	});

	return updatedObj;
}
